const NAMESPACE = "manageRequestContactInfo";

const KEYS = {
    contactInfoPreviewUpdatedBadge: "contactInfoPreviewUpdatedBadge",
    contactInfoPreviewOriginalBadge: "contactInfoPreviewOriginalBadge",
    contactInfoPreviewManuallyUpdatedBadge: "contactInfoPreviewManuallyUpdatedBadge",
    hideLinkLabel: "hideLinkLabel",
    showOriginalContactInfoLinkLabel: "showOriginalContactInfoLinkLabel"
};

const MESSAGES = {
    [KEYS.contactInfoPreviewUpdatedBadge]: {
        value: "Updated",
        comment: "Text that indicates a preview of updated contact info"
    },
    [KEYS.contactInfoPreviewOriginalBadge]: {
        value: "Original",
        comment: "Text that indicates a summary of the original contact info before an update"
    },
    [KEYS.contactInfoPreviewManuallyUpdatedBadge]: {
        value: "Manually Updated",
        comment: "Text that indicates a summary of contact info after a manual update"
    },
    [KEYS.hideLinkLabel]: {
        value: "Hide",
        comment: "Link for hiding options"
    },
    [KEYS.showOriginalContactInfoLinkLabel]: {
        value: "Show original",
        comment: "Label for link to show original contact info"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
